import React from "react";
import { Wrapper } from "./EndMessage.style";

export default () => (<Wrapper>
        Daugiau žinučių nėra.
    </Wrapper>
);